<template>
  <div>
    <div class="falcon-chart" :style="{'height': print? '200px':'400px'}" :class="locked? 'locked': ''" ref="chart">

    </div>
    <div class="chart-label">
      Valuations amount ranges in Million of Dollars
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import {CHART_COLORS, FONT_FAMILY} from "./chartColors";
import echarts from "echarts";
import {formatMillionsDollars} from "../../moneyUtils";

export default {
  name: 'industryRangeGraph',
  data() {
    return {
      graphData: this.data,
    }
  },
  props: ['data', 'color', 'locked', 'print', 'barWidth'],
  mounted() {
    var myChart = echarts.init(this.$refs['chart'], null, {
      renderer: 'svg'
    });
    // specify chart configuration item and data
    var option = {
      tooltip: {
        show: true
      },
      textStyle: {
        fontFamily: FONT_FAMILY
      },
      barWidth: this.barWidth || (this.print? 20: 50),
      legend: {
        show: true,
        orient: 'vertical',
        right: 0,
        data: [{
          name: 'Number of startups',
          icon: 'circle'
        },]
      },
      xAxis: {

        axisLine: {
          lineStyle: {
            color: '#899094'
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {

          fontSize: this.print ? 10 : 8,
          rotate: this.print ? 30 : 0
        },
        tickOptions: {showGridLine: false},
        type: 'category',
        data: ['Below 1M', '1M-2M', '2M-3M', '3M-4M', '4M+', '5M-6M', 'Above 6M']
      },
      yAxis: {
        axisLabel: {
          color: '#899094',
          // formatter: formatMillionsDollars
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: '#fff'

          },
        },
        splitLine: {
          lineStyle: {
            color: ['#E3E9EA'],
          }
        },
      },
      series: [

        {
          type: 'bar',
          name: 'Number of startups',
          data: [
            this.graphData.r1,
            this.graphData.r2,
            this.graphData.r3,
            this.graphData.r4,
            this.graphData.r5,
            this.graphData.r6,
            this.graphData.r7,
          ],
          itemStyle: {
            color: this.color,
            barBorderRadius: [5, 5, 0, 0]
          },
        }
      ]
    };

    myChart.setOption(option);
  },
  methods: {},
  computed: {},
}
</script>

<style scoped>
.falcon-chart {
  width: 100%;
  height: 250px;
}

.chart-label {
  text-align: center;
  font-size: 12px;
  color: #666
}
</style>
